import React, { memo } from "react";
import { Box } from "@mui/material";
import MessageBubble from "./MessageBubble";

const ChatMessageList = ({
  messages,
  isLoadingMore,
  messageContainerRef,
  onMediaClick,
  onEmojiReaction,
  onForwardMessage,
  onReplyToMessage,
  onViewOrder,
  onOpenPaymentDialog,
  onPaymentResponse,
  onOpenPaymentStrategyDialog,
  onOpenPaymentRequestDialog,
  onOpenPaymentConfirmationDialog,
  onSearchMenuItemByName,
  selectedContact,
  conversationInfo,
  isCurrentUserOwnerOrTeamMember,
  enableInAppWalletPayments,
  onOpenNotes,
  onViewLocation,
}) => {
  return (
    <Box
      ref={messageContainerRef}
      className="mobile-message-container"
      sx={{
        flex: 1,
        padding: (theme) => theme.spacing(2),
        paddingBottom: (theme) => theme.spacing(3),
        overflowY: "auto",
        overflowX: "hidden",
        display: "flex",
        flexDirection: "column",
        gap: (theme) => theme.spacing(2),
        "@media (max-width: 900px)": {
          padding: (theme) => theme.spacing(1.5),
          paddingBottom: (theme) => theme.spacing(10),
          gap: (theme) => theme.spacing(1.5),
          WebkitOverflowScrolling: "touch",
          scrollBehavior: "smooth",
          marginBottom: (theme) => theme.spacing(1),
          height: "calc(100vh - 64px - 64px)",
          scrollPaddingTop: "64px",
          overscrollBehavior: "contain",
        },
      }}
    >
      {/* Loading indicator for pagination */}
      {isLoadingMore && (
        <Box
          sx={{
            textAlign: "center",
            padding: { xs: 1.5, sm: 2 },
            color: "text.secondary",
            fontSize: { xs: "0.8rem", sm: "0.875rem" },
            backgroundColor: "rgba(0,0,0,0.05)",
            borderRadius: 1,
            margin: { xs: 0.75, sm: 1 },
          }}
        >
          loading more messages... ({messages.length} current)
        </Box>
      )}

      {messages.map((message) => (
        <MessageBubble
          key={message.id || message._id}
          message={message}
          isOwn={message.isOwn}
          onMediaClick={onMediaClick}
          onEmojiReaction={onEmojiReaction}
          onForwardMessage={onForwardMessage}
          onReplyToMessage={onReplyToMessage}
          onViewOrder={onViewOrder}
          onOpenPaymentDialog={onOpenPaymentDialog}
          onPaymentResponse={onPaymentResponse}
          onOpenPaymentStrategyDialog={onOpenPaymentStrategyDialog}
          onOpenPaymentRequestDialog={onOpenPaymentRequestDialog}
          onOpenPaymentConfirmationDialog={onOpenPaymentConfirmationDialog}
          onSearchMenuItemByName={onSearchMenuItemByName}
          selectedContact={selectedContact}
          conversationInfo={conversationInfo}
          isCurrentUserOwnerOrTeamMember={isCurrentUserOwnerOrTeamMember}
          enableInAppWalletPayments={enableInAppWalletPayments}
          businessLocationName={
            conversationInfo?.businessLocationId?.businessLocationName
          }
          onOpenNotes={onOpenNotes}
          onViewLocation={onViewLocation}
        />
      ))}
    </Box>
  );
};

export default memo(ChatMessageList);
